<script setup lang="ts">
import { ref } from 'vue'
import { FilterField, TableField } from "../../../../components/table/table";
import { Permission } from '../../../../types/auth'
import ListTemplate from "../../../../components/ui/common/ListTemplate.vue";
import VendorsForm from './VendorsForm.vue';

withDefaults(defineProps<{
  showHeader?: boolean,
  showQuickTour?: boolean,
  showTitle?: boolean,
  showNextButton?: boolean
  permissions?: Permission[]
}>(), {
  showHeader: true,
  showQuickTour: true,
  showTitle: true
})

const endPoint = '/clients/procurement/master-data/vendors/'
const title = 'Vendors'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const fields: TableField[] = [
  { name: 'name', caption: 'Name', sortable: true, fieldType: 'text' },
  { name: 'vendor_type', caption: 'Vendor Type', sortable: true, fieldType: 'text' },
  { name: 'country', caption: 'Country', sortable: true, fieldType: 'text' },
  { name: 'credit_term', caption: 'Credit Term', sortable: true, fieldType: 'text' },
  { name: 'credit_limit', caption: 'Credit Limit', sortable: true, fieldType: 'text' },
  { name: 'mobile', caption: 'Mobile', sortable: true, fieldType: 'text' },
  { name: 'send_invoice_via', caption: 'Send Invoice Via', sortable: true, fieldType: 'text' },
  { name: 'registration_no', caption: 'Registration No', sortable: true, fieldType: 'text' },
  { name: 'registration_date', caption: 'Registration Date', sortable: true, fieldType: 'date' },
  { name: 'tax_identification_no', caption: 'Tax Identification No', sortable: true, fieldType: 'text' },
  { name: 'buyer', caption: 'Assigned Buyer', sortable: true, fieldType: 'text' },
  { name: 'email', caption: 'Email', sortable: true, fieldType: 'text' },
  { name: 'active', caption: 'active', sortable: false, fieldType: 'status' },
]

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
     options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
]

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const permissions = ref<Permission[]>()
const handleData = (data : any) => {
  selectedData.value = data
}
</script>

<template>
  <ListTemplate :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "[]" :filterFields ="filterFields"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" 
  @data="handleData" :show-header="showHeader" :show-quick-tour="showQuickTour" :show-title="showTitle" @permissions="permissions = $event">
  <template #form-view>
    <VendorsForm
      :permissions="permissions"
      v-if="showForm"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />
  </template>
  </ListTemplate>
</template>